var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUspCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 4.5,
  y: 4.5,
  fill: "currentColor",
  stroke: "#fff",
  strokeDasharray: "1 2",
  rx: 11.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFDF9",
  d: "m22.61 12.682-8.528 8.528-4.744-4.744.944-.943 3.8 3.8 7.584-7.585z"
})));
export default SvgUspCheckmark;